/** @format */
import { css } from 'styled-components';

import { SocialChannelsProps } from './types';

const baseStyles = css`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    column-gap: var(--layout-spacing-24);

    .icon {
        cursor: pointer;
    }
`;

/**
 * The social channels component styles
 *
 * @param {SocialChannelsProps} props The social channels properties object
 * */
export const styles = (props: SocialChannelsProps) => css`
    ${baseStyles}
`;
